import { all } from 'redux-saga/effects';
import watchSignatureSaga from './signature/saga';

export default function* rootSaga() {
  yield all([watchSignatureSaga()]);
}
